export default __webpack_public_path__ + "static/media/cart-icon.2c51c2f2.svg";